export const FIND_FORM_TEMPLATE_CONSTANTS = {
  VAR: { ES_CO: "es-CO" },
  EMIT: { INSERT_FORM_TEMPALTE: "insertFormTemplate", CLOSE: "close" }
};
